import type { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useBidSelectFilterStyles = makeStyles((theme: Theme) => ({
    container: {
        padding: theme.spacing(1),
    },
    rangeContainer: {
        margin: theme.spacing(1),
        display: "flex",
        gap: theme.spacing(1),
        alignItems: "center",
        fontSize: 12,
    },
    input: {
        fontSize: 12,
        marginTop: 2,
        width: 40,
        cursor: "pointer",
        '&[type="number"]': {
            "-webkit-appearance": "textfield",
            "-moz-appearance": "textfield",
            appearance: "textfield",
        },
        '&[type="number"]::-webkit-inner-spin-button': {
            "-webkit-appearance": "none",
        },
        '&[type="number"]::-webkit-outer-spin-button': {
            "-webkit-appearance": "none",
        },
    },
    field: {
        width: 150,
    },
    button: {
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    checkboxContainer: {
        marginLeft: theme.spacing(1),
    },
    checkboxLabel: {
        fontSize: "0.8em",
    },
}));
